import { Button, Modal } from "antd";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import icon from "../../../assets/images/modal-icon-api-error.svg";
import { ErrorDto } from "../../../core/models/dtos/error.dto";
import { setApiError } from "../../../core/services/appService/setApiError/actions";
import { SetApiErrorState } from "../../../core/services/appService/setApiError/types";
import { Errors } from "../../../core/utilities/errors";
import { IStore } from "../../../core/utilities/reducers";
import { UI } from "../../../core/utilities/ui";
import "./ApiErrorModal.scss";

interface IProps {
  apiErrorState: SetApiErrorState;
  setApiError: (error?: ErrorDto) => void;
}

const ApiErrorModal = (props: IProps) => {
  const isVisible = (): boolean => {
    const errorDto = props.apiErrorState.error;
    return (
      !!errorDto &&
      !Errors.isPickedAnswerError(errorDto) &&
      !Errors.isOtpInvalidError(errorDto) &&
      !Errors.isOtpGeneralError(errorDto) &&
      !Errors.isOtpBalanceError(errorDto) &&
      !Errors.isSaveFailedError(errorDto) &&
      !Errors.isEtkError(errorDto) &&
      !Errors.isHandledWithPaymentErrorModal(errorDto)
    );
  };

  const getTitle = (error: ErrorDto): string => {
    switch (error.message) {
      default:
        return Errors.errorGenericTitle;
    }
  };

  const getText = (error: ErrorDto): string => {
    return error.message ?? Errors.errorGenericText;
  };

  return (
    <Modal
      className="api-error-modal"
      maskStyle={UI.modalMaskStyle()}
      visible={isVisible()}
      closable={false}
      footer={false}
      centered
      destroyOnClose
      onCancel={() => props.setApiError()}
    >
      {props.apiErrorState.error && (
        <div className="content">
          <img className="icon" src={icon} alt="icon" />
          <span className="title">{getTitle(props.apiErrorState.error)}</span>
          <span className="text">{getText(props.apiErrorState.error)}</span>
          <Button className="app-button" onClick={() => props.setApiError()}>
            TAMAM
          </Button>
        </div>
      )}
    </Modal>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setApiError,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    apiErrorState: store.setApiError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiErrorModal);
